module.exports = __webpack_public_path__ + "media/music/synth_chords_4-4c0326de.mp3";